<template>
  <div class="flex p-1 items-center menu_item">
    <a
      class="button is-white p-1 w-full flex justify-start"
      :class="computedClasses"
      @click="onClickHandler"
    >
      <img class="pr-2" />
      {{ textOption }}
      <span v-if="selected" class="ml-auto text-black font-bold">✓</span>
    </a>
  </div>
</template>

<script>
import { noop } from "@/utils/functions";
export default {
  props: {
    textOption: {
      type: String,
      default: ""
    },
    onClickHandler: {
      type: Function,
      default: noop
    },
    itemColorStyle: {
      type: Object,
      default: () => ({})
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedClasses() {
      return [
        this.selected ? "font-bold text-black" : "text-gray-500",
        "hover:bg-red-300 hover:text-black"
      ];
    }
  }
};
</script>
